module.exports = __webpack_public_path__ + "img/744.249e2d0d.jpg";